import { openAuthWindow } from '../utils/fn';

let loginRedirectMarked = false;
let coralCommentsLoaded = false;

export function isCoralCommentsLoaded() {
  return coralCommentsLoaded;
}

function setDefaultCoralSorting() {
  const coralNS = 'coral:';
  const sortKeyName = `${coralNS}localState:commentsOrderBy`;

  let defaultSorting = 'REACTION_DESC';

  try {
    const oldValue = localStorage.getItem(sortKeyName);
    if (oldValue) return;

    localStorage.setItem(sortKeyName, defaultSorting);
  } catch {
    //
  }
}

/**
 * Coral fires "ready" before the stream is painted, so the pulsing skeleton
 * stays until the comment list itself is in the shadow root, then goes away.
 * The deadline keeps a failed render from pinning the skeleton on screen.
 * @param {Element | null} container - #coral_thread_app
 */
function removeSkeletonWhenCommentsRender(container) {
  const placeholder = document.getElementById('coral_placeholder');

  if (!placeholder) return;

  const deadline = Date.now() + 10000;

  const check = () => {
    const shadowRoot = container?.querySelector('div')?.shadowRoot;

    if (
      shadowRoot?.querySelector('[data-test-id="virtuoso-item-list"]') ||
      Date.now() > deadline
    ) {
      placeholder.remove();
      return;
    }

    setTimeout(check, 100);
  };

  check();
}

export async function initCoralComments() {
  // console.log('function called!!!!!!!!!!!!!!!!!!!');

  coralCommentsLoaded = true;

  const commentsContainer = document.querySelector('#coral_thread_app');
  const customScrollContainerEl = commentsContainer?.closest(
    '.msnt-dialog__content',
  );
  console.log('customScrollContainerEl', customScrollContainerEl);

  let accessToken = null;
  let colorScheme = window.parent.document.documentElement.dataset.colorScheme;

  if (!colorScheme) {
    colorScheme = 'light';
  }

  document.documentElement.dataset.colorScheme = colorScheme;
  const data = commentsContainer?.dataset;

  setDefaultCoralSorting();

  const { baseUrl, embedPath, articleId, articleUrl } = data;

  try {
    const response = await fetch(`${window.location.origin}/coral-jwt/`).then(
      (data) => data.json(),
    );
    accessToken = response.data?.token;
  } catch (error) {
    console.error(error);
  }

  var d = document,
    s = d.createElement('script');

  s.src = `${baseUrl}${embedPath}`;
  s.async = false;
  s.defer = true;

  s.onload = function () {
    const api = Coral.createStreamEmbed({
      id: 'coral_thread_app',
      autoRender: true,
      rootURL: baseUrl,
      storyID: articleId,
      storyURL: articleUrl,
      containerClassName: 'coral-container-' + colorScheme,
      customScrollContainer: customScrollContainerEl,
      accessToken,
      events: function (events) {
        events.on('loginPrompt', function () {
          openAuthWindow('/sign-in/');
          if (!loginRedirectMarked && window.location.hash !== '#comments') {
            loginRedirectMarked = true;
            const url = new URL(window.location.href);
            url.searchParams.set('commentsLogin', '1');

            window.history.replaceState(
              null,
              null,
              `${url.pathname}${url.search}#comments`,
            );
          }
        });

        events.onAny(function (eventName) {
          if (eventName === 'ready') {
            console.log('coral comments has been loaded!');
            removeSkeletonWhenCommentsRender(commentsContainer);
          }
        });
      },
    });

    import('./comments-ads-virtual').then((module) => {
      module.default(api, data);
      api.render();
    });
  };

  (d.head || d.body).appendChild(s);
}
